module.exports = __webpack_public_path__ + "img/emo_36.027f9cdb.png";